module.exports = __webpack_public_path__ + "static/media/choithramsAashirvaadS.b5594293.png";